import styled from "styled-components";
import {GradientDefaultBox} from "./gradient.default.box";
import {hexToRgba} from "../../../../../themes/hex-to-rgba";

export const GradientCasino777Box = styled(GradientDefaultBox)`
  background: linear-gradient(to bottom, ${props => hexToRgba(props.theme.colors.backgroundContrast, 0.3)}, ${props => hexToRgba(props.theme.colors.background, 0.6)});
`